import accountReducer from './reducer';
import * as accountActions from './actions';

export { default } from './AccountPage';
export const reducer = accountReducer;
export const actions = accountActions;
